<div [formGroup]="formularzUszkodzenia">
    <label class="c-label">
        <span class="c-label__title" [class.text-danger]="WARTOSC.errors && (WARTOSC.touched || WARTOSC.dirty)">
            {{miaraJednostkiUszkodzenia}}  (<span *ngIf="jednostkaPowierzchniUszkodzenia !== 'm2' else m2">{{jednostkaPowierzchniUszkodzenia === 'kpl.' ? 'szt.' : jednostkaPowierzchniUszkodzenia}}</span>)
        </span>
        <input *ngIf="withPeriod; else decimal" [id]="'wartosc'" formControlName="wartosc" type="number" class="c-input" value="" title="" appNumbersOnly [withPeriod]=withPeriod() />
        <ng-template #decimal>
            <input [id]="'wartosc'" formControlName="wartosc" type="number" class="c-input" value="" title="" />
        </ng-template>
        <div *ngIf="WARTOSC.errors && (WARTOSC.touched || WARTOSC.dirty)">
          <span *ngIf="czyWalidacjaWgPowierzchni else minimum" class="c-label__title text-danger u-margin-right-tiny">
              {{
              !!maksymalnaWartoscUszkodzenia  ?
                  'Dane powinny być z zakresu od ' + (minimalnaWartoscUszkodzenia.toFixed(2) | number:'': language)  + ' do ' +
                  ((withPeriod() ? maksymalnaWartoscUszkodzenia.toFixed(2) : maksymalnaWartoscUszkodzenia) | number :'':language) : czyWalidacjaWgPowierzchni ? 'Wymiary ' + pobierzNazweElementu() + ' są wymagane' : ''
              }}
          </span>
        </div>
    </label>
</div>

<ng-template #minimum>
  <span class="c-label__title text-danger u-margin-right-tiny">
      {{
      !!maksymalnaWartoscUszkodzenia ?
          'Dane powinny być z zakresu od ' +
          ((withPeriod() ? minimalnaWartoscUszkodzenia.toFixed(2) : minimalnaWartoscUszkodzenia) | number : '':language) +
          ' do ' +
          ((withPeriod() ? maksymalnaWartoscUszkodzenia.toFixed(2) : maksymalnaWartoscUszkodzenia ) | number : '':language) :
          'Dane powinny być z zakresu od ' +
          minimalnaWartoscUszkodzenia.toFixed(2) | number : '':language
      }}
  </span>
</ng-template>

<ng-template #m2>
  <span>m<sup>2</sup></span>
</ng-template>
